(() => {
  'use strict';

  const STORAGE_KEY = 'trmSelectedVehicleV1';
  const ROUTE_SUFFIXES = [
    'accessories-lighting',
    'wheels-tires',
    'performance',
    'suspension',
    'steering',
    'parts'
  ];

  const garage = document.querySelector('[data-trm-garage]');

  if (!garage) return;

  const selectorState = garage.querySelector('[data-trm-garage-selector]');
  const activeState = garage.querySelector('[data-trm-garage-active]');
  const labelElement = garage.querySelector('[data-trm-garage-label]');
  const changeButton = garage.querySelector('[data-trm-garage-change]');
  const clearButton = garage.querySelector('[data-trm-garage-clear]');
  const setButton = garage.querySelector('[data-trm-garage-set]');
  const makeSelect = garage.querySelector('[data-trm-garage-make]');
  const modelSelect = garage.querySelector('[data-trm-garage-model]');
  const generationSelect = garage.querySelector(
    '[data-trm-garage-generation]'
  );
  const dataElement = garage.querySelector('[data-trm-garage-data]');
  const shopLink = garage.querySelector('[data-trm-garage-shop-link]');
  const mobileOpenButton = garage.querySelector(
    '[data-trm-garage-mobile-open]'
  );
  const mobileLabel = garage.querySelector(
    '[data-trm-garage-mobile-label]'
  );
  const mobileEyebrow = garage.querySelector(
    '[data-trm-garage-mobile-eyebrow]'
  );

  const modal = garage.querySelector('[data-trm-garage-modal]');
  const modalDialog = modal?.querySelector('.trm-garage-modal__dialog');
  const modalGrid = modal?.querySelector('[data-trm-garage-modal-grid]');
  const modalEmpty = modal?.querySelector('[data-trm-garage-modal-empty]');
  const modalBack = modal?.querySelector('[data-trm-garage-modal-back]');
  const modalProgress = modal?.querySelector(
    '[data-trm-garage-modal-progress]'
  );
  const modalEyebrow = modal?.querySelector(
    '[data-trm-garage-modal-eyebrow]'
  );
  const modalTitle = modal?.querySelector(
    '[data-trm-garage-modal-title]'
  );
  const modalDescription = modal?.querySelector(
    '[data-trm-garage-modal-description]'
  );
  const modalSelection = modal?.querySelector(
    '[data-trm-garage-modal-selection]'
  );
  const modalSelectionLabel = modal?.querySelector(
    '[data-trm-garage-modal-selection-label]'
  );

  const normalize = (value = '') =>
    value
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/\+/g, '-plus-')
      .replace(/['’]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const cleanVehicleLabel = (value = '') =>
    value
      .toString()
      .replace(
        /\s+(Parts|Suspension|Steering|Performance|Wheels\s*&\s*Tires|Accessories\s*&\s*Lighting)$/i,
        ''
      )
      .replace(
        /\s*(?:→|➜|➞|➝|➤|›|»|->|–>|—>)\s*$/u,
        ''
      )
      .replace(/\s+/g, ' ')
      .trim();

  const stripKnownSuffix = (handle = '') => {
    for (const suffix of ROUTE_SUFFIXES) {
      const token = `-${suffix}`;

      if (handle.endsWith(token)) {
        return handle.slice(0, -token.length);
      }
    }

    return handle;
  };

  const knownRouteSuffix = (handle = '') => {
    for (const suffix of ROUTE_SUFFIXES) {
      if (handle.endsWith(`-${suffix}`)) {
        return suffix;
      }
    }

    return '';
  };

  const parseGarageImageSettings = () => {
    try {
      const element = document.getElementById(
        'TRMGarageImageSettings'
      );

      const data = JSON.parse(
        element?.textContent || '{}'
      );

      return data && typeof data === 'object'
        ? data
        : {};
    } catch (error) {
      console.warn(
        'TRM garage image settings could not be parsed.',
        error
      );
      return {};
    }
  };

  const parseVehicleData = () => {
    try {
      const data = JSON.parse(dataElement?.textContent || '[]');
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.warn(
        'TRM garage vehicle data could not be parsed.',
        error
      );
      return [];
    }
  };

  const garageImageSettings =
    parseGarageImageSettings();

  const vehicleData = parseVehicleData().map(
    (make) => ({
      ...make,
      image:
        garageImageSettings[normalize(make.key)] ||
        garageImageSettings[
          normalize(make.title)
        ] ||
        ''
    })
  );

  const resetSelect = (select, placeholder) => {
    if (!select) return;

    select.innerHTML = '';
    select.appendChild(new Option(placeholder, ''));
    select.value = '';
    select.disabled = true;
  };

  const populateSelect = (select, items, placeholder) => {
    if (!select) return;

    select.innerHTML = '';
    select.appendChild(new Option(placeholder, ''));

    items.forEach((item) => {
      select.appendChild(new Option(item.title, item.key));
    });

    select.disabled = items.length === 0;
    select.value = '';
  };

  const findMake = (key) =>
    vehicleData.find(
      (make) => normalize(make.key) === normalize(key)
    );

  const findModel = (make, key) =>
    make?.models?.find(
      (model) => normalize(model.key) === normalize(key)
    );

  const findGenerationByKey = (key) => {
    for (const make of vehicleData) {
      for (const model of make.models || []) {
        const generation = (model.generations || []).find(
          (item) => normalize(item.key) === normalize(key)
        );

        if (generation) {
          return {
            make,
            model,
            generation
          };
        }
      }
    }

    return null;
  };

  const readVehicle = () => {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);

      if (!raw) return null;

      const parsed = JSON.parse(raw);

      if (!parsed?.key || !parsed?.label) return null;

      const cleanedLabel = cleanVehicleLabel(parsed.label);

      if (!cleanedLabel) return null;

      if (cleanedLabel !== parsed.label) {
        parsed.label = cleanedLabel;

        window.localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify(parsed)
        );
      }

      return parsed;
    } catch (error) {
      return null;
    }
  };

  const renderGarage = (vehicle, forceSelector = false) => {
    const hasVehicle = Boolean(vehicle?.key && vehicle?.label);
    const showSelector = forceSelector || !hasVehicle;

    if (selectorState) {
      selectorState.hidden = !showSelector;
    }

    if (activeState) {
      activeState.hidden = showSelector || !hasVehicle;
    }

    if (hasVehicle && labelElement) {
      labelElement.textContent = vehicle.label;
    }

    if (shopLink) {
      shopLink.href = hasVehicle
        ? (vehicle.sourceUrl || `/collections/${vehicle.key}-parts`)
        : '/pages/shop-by-vehicle?view=shop-by-vehicle';
    }

    if (mobileLabel) {
      mobileLabel.textContent = hasVehicle
        ? vehicle.label
        : 'Choose your truck';
    }

    if (mobileEyebrow) {
      mobileEyebrow.textContent = hasVehicle
        ? 'My saved vehicle'
        : 'My Truck Garage';
    }

    garage.classList.toggle(
      'is-editing',
      showSelector && hasVehicle
    );
  };

  const saveVehicle = (
    vehicle,
    { preservePage = false } = {}
  ) => {
    if (!vehicle?.key || !vehicle?.label) return null;

    const resolved = findGenerationByKey(vehicle.key);

    const payload = {
      key: normalize(vehicle.key),
      label: cleanVehicleLabel(vehicle.label),
      sourceUrl:
        vehicle.sourceUrl ||
        resolved?.generation?.url ||
        '',
      makeKey:
        vehicle.makeKey ||
        resolved?.make?.key ||
        '',
      modelKey:
        vehicle.modelKey ||
        resolved?.model?.key ||
        '',
      savedAt: Date.now()
    };

    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(payload)
    );

    renderGarage(payload);

    window.dispatchEvent(
      new CustomEvent('trm:vehicle-changed', {
        detail: {
          ...payload,
          preservePage
        }
      })
    );

    return payload;
  };

  const resetGarageForm = () => {
    if (makeSelect) {
      makeSelect.value = '';
    }

    resetSelect(modelSelect, 'Model');
    resetSelect(
      generationSelect,
      'Year / Generation'
    );

    if (setButton) {
      setButton.disabled = true;
    }
  };

  const removeVehicle = () => {
    closeModal();

    window.localStorage.removeItem(STORAGE_KEY);

    resetGarageForm();
    renderGarage(null);

    window.dispatchEvent(
      new CustomEvent('trm:vehicle-cleared')
    );

    const currentUrl = new URL(window.location.href);

    for (const key of Array.from(currentUrl.searchParams.keys())) {
      if (key.includes('custom.vehicle_groups')) {
        currentUrl.searchParams.delete(key);
      }
    }

    if (currentUrl.href !== window.location.href) {
      window.location.assign(currentUrl.href);
    }
  };

  const prefillGarageForm = (vehicle) => {
    const resolved = findGenerationByKey(vehicle?.key);

    resetGarageForm();

    if (!resolved || !makeSelect || !setButton) return;

    makeSelect.value = resolved.make.key;

    populateSelect(
      modelSelect,
      resolved.make.models || [],
      'Model'
    );

    modelSelect.value = resolved.model.key;

    populateSelect(
      generationSelect,
      resolved.model.generations || [],
      'Year / Generation'
    );

    generationSelect.value = resolved.generation.key;
    setButton.disabled = false;
  };

  const selectedGeneration = () => {
    const make = findMake(makeSelect?.value);
    const model = findModel(make, modelSelect?.value);

    const generation = model?.generations?.find(
      (item) =>
        normalize(item.key) ===
        normalize(generationSelect?.value)
    );

    if (!make || !model || !generation) {
      return null;
    }

    return {
      key: generation.key,
      label: generation.title,
      sourceUrl: generation.url,
      makeKey: make.key,
      modelKey: model.key
    };
  };

  const vehicleFromAnchor = (anchor) => {
    const url = new URL(
      anchor.href,
      window.location.origin
    );

    const handle =
      url.pathname
        .split('/collections/')[1]
        ?.split('/')[0] || '';

    const key = stripKnownSuffix(handle);
    const label = cleanVehicleLabel(anchor.textContent);

    if (!key || !label) return null;

    return {
      key,
      label,
      sourceUrl: url.pathname
    };
  };

  const captureVehicleSelection = (event) => {
    const filterButton = event.target.closest(
      '[data-trm-filter-generation]'
    );

    if (filterButton) {
      saveVehicle({
        key:
          filterButton.dataset.trmVehicleKey ||
          normalize(
            filterButton.dataset.trmVehicleLabel
          ),
        label:
          filterButton.dataset.trmVehicleLabel ||
          filterButton.textContent.trim(),
        sourceUrl: window.location.pathname
      });

      return;
    }

    const anchor = event.target.closest('a');

    if (!anchor) return;

    const isVehicleBrowserLink = Boolean(
      anchor.closest('.trm-generation-links')
    );

    const isCollectionSelectorLink = Boolean(
      anchor.classList.contains(
        'trm-collection-vehicle-selector__generation'
      )
    );

    if (
      !isVehicleBrowserLink &&
      !isCollectionSelectorLink
    ) {
      return;
    }

    const vehicle = vehicleFromAnchor(anchor);

    if (vehicle) {
      saveVehicle(vehicle);
    }
  };

  const inferVehicleFromCurrentCollection = () => {
    const pageType =
      garage.dataset.pageType || '';

    const collectionHandle =
      garage.dataset.collectionHandle || '';

    const collectionTitle =
      garage.dataset.collectionTitle || '';

    if (
      pageType !== 'collection' ||
      !collectionHandle
    ) {
      return null;
    }

    if (collectionHandle.startsWith('trm-')) {
      return null;
    }

    const key = stripKnownSuffix(collectionHandle);

    if (!key || key === collectionHandle) {
      return null;
    }

    return {
      key,
      label: cleanVehicleLabel(collectionTitle),
      sourceUrl: window.location.pathname
    };
  };

  const currentVehicleCollectionContext = () => {
    const pageType =
      garage.dataset.pageType || '';

    const collectionHandle =
      garage.dataset.collectionHandle || '';

    if (
      pageType !== 'collection' ||
      !collectionHandle ||
      collectionHandle.startsWith('trm-')
    ) {
      return null;
    }

    const suffix =
      knownRouteSuffix(collectionHandle);

    const vehicleKey =
      stripKnownSuffix(collectionHandle);

    if (
      !suffix ||
      !vehicleKey ||
      vehicleKey === collectionHandle ||
      !findGenerationByKey(vehicleKey)
    ) {
      return null;
    }

    return {
      suffix,
      vehicleKey
    };
  };

  const replaceCurrentPage = (rawUrl) => {
    if (!rawUrl) return false;

    const targetUrl = new URL(
      rawUrl,
      window.location.origin
    );

    if (
      targetUrl.pathname.startsWith(
        '/collections/'
      )
    ) {
      targetUrl.search = '';
      targetUrl.hash = '';
    }

    const currentUrl = new URL(
      window.location.href
    );

    if (
      targetUrl.pathname === currentUrl.pathname &&
      targetUrl.search === currentUrl.search &&
      targetUrl.hash === currentUrl.hash
    ) {
      return true;
    }

    window.location.replace(targetUrl.href);
    return true;
  };

  const routeVehicleCollection = (vehicle) => {
    const context =
      currentVehicleCollectionContext();

    if (!context) return false;

    const resolved =
      findGenerationByKey(vehicle?.key);

    const vehicleSourceUrl =
      vehicle?.sourceUrl ||
      resolved?.generation?.url ||
      '';

    let targetUrl = '';

    if (context.suffix === 'parts') {
      targetUrl = vehicleSourceUrl;
    } else {
      targetUrl =
        resolved?.generation?.contextUrl ||
        '';
    }

    return replaceCurrentPage(
      targetUrl ||
      vehicleSourceUrl ||
      '/pages/shop-by-vehicle'
    );
  };

  const findBrandSelectorButton = (vehicle) =>
    Array.from(
      document.querySelectorAll(
        '[data-trm-filter-generation]'
      )
    ).find((button) => {
      const buttonKey =
        normalize(button.dataset.trmVehicleKey) ||
        normalize(button.dataset.trmVehicleLabel);

      return buttonKey === vehicle.key;
    });

  const autoApplyToBrandCollection = (vehicle) => {
    const collectionHandle =
      garage.dataset.collectionHandle || '';

    if (
      !collectionHandle.startsWith('trm-brand-')
    ) {
      return;
    }

    let attempts = 0;
    const maxAttempts = 40;

    const tryApply = () => {
      const button =
        findBrandSelectorButton(vehicle);

      if (button) {
        if (
          !button.classList.contains('is-active')
        ) {
          button.click();
        }

        return;
      }

      attempts += 1;

      if (attempts < maxAttempts) {
        window.setTimeout(tryApply, 150);
      }
    };

    tryApply();
  };

  const mainCategorySuffix = () => {
    const title = (
      garage.dataset.collectionTitle || ''
    ).trim();

    const map = {
      'Truck Suspension & Lift Kits':
        'suspension',
      'Truck Steering Components':
        'steering',
      'Truck Performance Parts':
        'performance',
      'Truck Wheels & Tires':
        'wheels-tires',
      'Truck Accessories & Lighting':
        'accessories-lighting'
    };

    return map[title] || '';
  };

  const autoRouteMainCategory = (vehicle) => {
    const suffix = mainCategorySuffix();

    if (!suffix) return false;

    let attempts = 0;
    const maxAttempts = 40;

    const expectedToken =
      `/collections/${vehicle.key}-${suffix}`;

    const tryRoute = () => {
      const link = Array.from(
        document.querySelectorAll(
          '.trm-collection-vehicle-selector__generation[href]'
        )
      ).find((candidate) =>
        new URL(
          candidate.href,
          window.location.origin
        )
          .pathname
          .includes(expectedToken)
      );

      if (link) {
        const targetUrl = new URL(
          link.href,
          window.location.origin
        );

        if (
          targetUrl.pathname !==
          window.location.pathname
        ) {
          window.location.replace(
            targetUrl.href
          );
        }

        return;
      }

      attempts += 1;

      if (attempts < maxAttempts) {
        window.setTimeout(tryRoute, 150);
      }
    };

    tryRoute();

    return true;
  };

  const autoApplyToSearch = (vehicle) => {
    if (
      (garage.dataset.pageType || '') !==
      'search'
    ) {
      return;
    }

    let attempts = 0;
    const maxAttempts = 40;

    const tryApply = () => {
      const inputs = Array.from(
        document.querySelectorAll(
          '#FacetFiltersForm .js-filter[data-name*="custom.vehicle_groups"] input[type="checkbox"]'
        )
      );

      const matchingInput = inputs.find(
        (input) => {
          const label =
            input.getAttribute('aria-label') || '';

          return (
            normalize(label) ===
            normalize(vehicle.label)
          );
        }
      );

      if (matchingInput) {
        if (
          !matchingInput.checked &&
          !matchingInput.disabled
        ) {
          matchingInput.checked = true;

          matchingInput.dispatchEvent(
            new Event('input', {
              bubbles: true
            })
          );
        }

        return;
      }

      attempts += 1;

      if (attempts < maxAttempts) {
        window.setTimeout(tryApply, 150);
      }
    };

    tryApply();
  };

  const navigateAfterSet = (
    vehicle,
    { fromModal = false } = {}
  ) => {
    const collectionHandle =
      garage.dataset.collectionHandle || '';

    const pageType =
      garage.dataset.pageType || '';

    if (['product', 'cart'].includes(pageType)) {
      return;
    }

    if (
      collectionHandle.startsWith('trm-brand-')
    ) {
      autoApplyToBrandCollection(vehicle);
      return;
    }

    if (routeVehicleCollection(vehicle)) {
      return;
    }

    if (autoRouteMainCategory(vehicle)) {
      return;
    }

    if (pageType === 'search') {
      autoApplyToSearch(vehicle);
      return;
    }

    if (fromModal) {
      return;
    }

    if (vehicle.sourceUrl) {
      const targetUrl = new URL(
        vehicle.sourceUrl,
        window.location.origin
      );

      if (
        targetUrl.pathname !==
        window.location.pathname
      ) {
        window.location.assign(
          targetUrl.href
        );
      }
    }
  };

  const modalState = {
    step: 'make',
    make: null,
    model: null
  };

  let modalReturnFocus = null;
  let lockedScrollY = 0;
  let originalBodyStyles = null;

  const lockPage = () => {
    if (document.documentElement.classList.contains(
      'trm-garage-modal-open'
    )) {
      return;
    }

    lockedScrollY = window.scrollY;

    originalBodyStyles = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      width: document.body.style.width,
      overflow: document.body.style.overflow
    };

    document.documentElement.classList.add(
      'trm-garage-modal-open'
    );

    document.body.style.position = 'fixed';
    document.body.style.top = `-${lockedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  };

  const unlockPage = () => {
    if (!document.documentElement.classList.contains(
      'trm-garage-modal-open'
    )) {
      return;
    }

    document.documentElement.classList.remove(
      'trm-garage-modal-open'
    );

    if (originalBodyStyles) {
      Object.assign(
        document.body.style,
        originalBodyStyles
      );
    }

    window.scrollTo(0, lockedScrollY);
    originalBodyStyles = null;
  };

  const modalIsOpen = () =>
    Boolean(
      modal &&
      !modal.hidden &&
      modal.getAttribute('aria-hidden') === 'false'
    );

  const getModalFocusable = () => {
    if (!modal) return [];

    return Array.from(
      modal.querySelectorAll(
        [
          'a[href]',
          'button:not([disabled]):not([hidden])',
          '[tabindex]:not([tabindex="-1"])'
        ].join(',')
      )
    ).filter(
      (element) =>
        !element.hasAttribute('hidden') &&
        element.offsetParent !== null
    );
  };

  const updateModalSelection = () => {
    if (!modalSelection || !modalSelectionLabel) return;

    const labels = [];

    if (modalState.make?.title) {
      labels.push(modalState.make.title);
    }

    if (modalState.model?.title) {
      labels.push(modalState.model.title);
    }

    modalSelection.hidden = labels.length === 0;
    modalSelectionLabel.textContent =
      labels.join(' · ');
  };

  const createImage = (src, alt) => {
    if (!src) return null;

    const image = document.createElement('img');
    image.src = src;
    image.alt = alt;
    image.loading = 'lazy';
    image.decoding = 'async';

    return image;
  };

  const createModalCard = ({
    item,
    type,
    image,
    current = false
  }) => {
    const button = document.createElement('button');

    button.type = 'button';
    button.className = [
      'trm-garage-modal__card',
      `trm-garage-modal__card--${type}`
    ].join(' ');
    button.dataset.trmGarageModalCard = type;
    button.dataset.trmGarageModalKey = item.key || '';

    if (current) {
      button.classList.add('is-current');
      button.setAttribute('aria-current', 'true');
    }

    if (type === 'make') {
      const media = document.createElement('span');
      media.className = 'trm-garage-modal__card-media';

      const cardImage = createImage(
        image || '',
        item.title || ''
      );

      if (cardImage) {
        media.appendChild(cardImage);
      } else {
        const fallback = document.createElement('span');
        fallback.className =
          'trm-garage-modal__card-fallback';
        fallback.setAttribute('aria-hidden', 'true');
        fallback.textContent =
          (item.title || '?').charAt(0).toUpperCase();
        media.appendChild(fallback);
        button.classList.add('has-fallback');
      }

      const overlay = document.createElement('span');
      overlay.className =
        'trm-garage-modal__card-overlay';
      media.appendChild(overlay);
      button.appendChild(media);
    }

    const copy = document.createElement('span');
    copy.className = 'trm-garage-modal__card-copy';

    const title = document.createElement('strong');
    title.className =
      'trm-garage-modal__card-title';
    title.textContent = item.title || '';

    const arrow = document.createElement('span');
    arrow.className =
      'trm-garage-modal__card-arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent =
      type === 'generation' ? '✓' : '→';

    copy.append(title, arrow);
    button.appendChild(copy);

    return button;
  };

  const modalCopy = {
    make: {
      progress: 'Step 1 of 3',
      eyebrow: 'Shop by vehicle',
      title: 'Choose your make',
      description:
        'Select a truck or SUV brand to begin.'
    },
    model: {
      progress: 'Step 2 of 3',
      eyebrow: 'Vehicle model',
      title: 'Choose your model',
      description:
        'Select the model you want to shop for.'
    },
    generation: {
      progress: 'Step 3 of 3',
      eyebrow: 'Year and generation',
      title: 'Choose year / generation',
      description:
        'This final selection powers product and cart fitment checks.'
    }
  };

  const renderModal = () => {
    if (
      !modalGrid ||
      !modalTitle ||
      !modalDescription
    ) {
      return;
    }

    const copy = modalCopy[modalState.step];

    if (modal) {
      modal.dataset.trmGarageModalStep =
        modalState.step;
    }

    if (modalProgress) {
      modalProgress.textContent = copy.progress;
    }

    if (modalEyebrow) {
      modalEyebrow.textContent = copy.eyebrow;
    }

    modalTitle.textContent =
      modalState.step === 'model' &&
      modalState.make?.title
        ? `Choose your ${modalState.make.title} model`
        : modalState.step === 'generation' &&
            modalState.model?.title
          ? `Choose your ${modalState.model.title}`
          : copy.title;

    modalDescription.textContent = copy.description;

    if (modalBack) {
      modalBack.hidden = modalState.step === 'make';
    }

    updateModalSelection();
    modalGrid.innerHTML = '';

    const currentVehicle = readVehicle();
    const resolvedCurrent = findGenerationByKey(
      currentVehicle?.key
    );

    let items = [];

    if (modalState.step === 'make') {
      items = vehicleData.map((make) => ({
        item: make,
        type: 'make',
        image: make.image || '',
        current:
          normalize(resolvedCurrent?.make?.key) ===
          normalize(make.key)
      }));
    } else if (modalState.step === 'model') {
      items = (modalState.make?.models || []).map(
        (model) => ({
          item: model,
          type: 'model',
          image:
            modalState.make?.image ||
            '',
          current:
            normalize(resolvedCurrent?.model?.key) ===
            normalize(model.key)
        })
      );
    } else {
      items = (
        modalState.model?.generations || []
      ).map((generation) => ({
        item: generation,
        type: 'generation',
        image:
          modalState.make?.image ||
          '',
        current:
          normalize(currentVehicle?.key) ===
          normalize(generation.key)
      }));
    }

    items.forEach((config) => {
      modalGrid.appendChild(
        createModalCard(config)
      );
    });

    if (modalEmpty) {
      modalEmpty.hidden = items.length > 0;
    }

    modalGrid.hidden = items.length === 0;

    window.requestAnimationFrame(() => {
      const currentCard =
        modalGrid.querySelector('.is-current');

      const firstCard =
        modalGrid.querySelector(
          '[data-trm-garage-modal-card]'
        );

      (currentCard || firstCard)?.focus({
        preventScroll: true
      });
    });
  };

  const openModal = (trigger = null) => {
    if (!modal || !modalDialog) {
      const selectedVehicle = readVehicle();

      prefillGarageForm(selectedVehicle);
      renderGarage(selectedVehicle, true);
      return;
    }

    modalReturnFocus =
      trigger instanceof HTMLElement
        ? trigger
        : document.activeElement;

    modalState.step = 'make';
    modalState.make = null;
    modalState.model = null;

    lockPage();

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');

    window.requestAnimationFrame(() => {
      modal.classList.add('is-open');
      renderModal();
      modalDialog.focus({
        preventScroll: true
      });
    });
  };

  function closeModal() {
    if (!modal || !modalIsOpen()) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    window.setTimeout(() => {
      modal.hidden = true;
      unlockPage();

      if (
        modalReturnFocus instanceof HTMLElement &&
        document.contains(modalReturnFocus)
      ) {
        modalReturnFocus.focus({
          preventScroll: true
        });
      }

      modalReturnFocus = null;
    }, 220);
  }

  const goModalBack = () => {
    if (modalState.step === 'generation') {
      modalState.step = 'model';
      modalState.model = null;
    } else if (modalState.step === 'model') {
      modalState.step = 'make';
      modalState.make = null;
    }

    renderModal();
  };

  const selectModalCard = (button) => {
    const type =
      button.dataset.trmGarageModalCard;
    const key =
      button.dataset.trmGarageModalKey;

    if (type === 'make') {
      const make = findMake(key);

      if (!make) return;

      modalState.make = make;
      modalState.model = null;
      modalState.step = 'model';
      renderModal();
      return;
    }

    if (type === 'model') {
      const model = findModel(
        modalState.make,
        key
      );

      if (!model) return;

      modalState.model = model;
      modalState.step = 'generation';
      renderModal();
      return;
    }

    if (type !== 'generation') return;

    const generation = (
      modalState.model?.generations || []
    ).find(
      (item) =>
        normalize(item.key) === normalize(key)
    );

    if (
      !generation ||
      !modalState.make ||
      !modalState.model
    ) {
      return;
    }

    const savedVehicle = saveVehicle(
      {
        key: generation.key,
        label: generation.title,
        sourceUrl: generation.url,
        makeKey: modalState.make.key,
        modelKey: modalState.model.key
      },
      {
        preservePage: true
      }
    );

    if (!savedVehicle) return;

    closeModal();

    navigateAfterSet(savedVehicle, {
      fromModal: true
    });
  };

  if (makeSelect) {
    makeSelect.addEventListener(
      'change',
      () => {
        const make =
          findMake(makeSelect.value);

        populateSelect(
          modelSelect,
          make?.models || [],
          'Model'
        );

        resetSelect(
          generationSelect,
          'Year / Generation'
        );

        if (setButton) {
          setButton.disabled = true;
        }
      }
    );
  }

  if (modelSelect) {
    modelSelect.addEventListener(
      'change',
      () => {
        const make =
          findMake(makeSelect?.value);

        const model =
          findModel(make, modelSelect.value);

        populateSelect(
          generationSelect,
          model?.generations || [],
          'Year / Generation'
        );

        if (setButton) {
          setButton.disabled = true;
        }
      }
    );
  }

  if (generationSelect) {
    generationSelect.addEventListener(
      'change',
      () => {
        if (setButton) {
          setButton.disabled =
            !selectedGeneration();
        }
      }
    );
  }

  if (setButton) {
    setButton.addEventListener(
      'click',
      () => {
        const vehicle =
          selectedGeneration();

        if (!vehicle) return;

        const preservePage = [
          'product',
          'cart'
        ].includes(
          garage.dataset.pageType || ''
        );

        const savedVehicle = saveVehicle(
          vehicle,
          { preservePage }
        );

        if (savedVehicle) {
          navigateAfterSet(savedVehicle);
        }
      }
    );
  }

  if (changeButton) {
    changeButton.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        openModal(changeButton);
      }
    );
  }

  if (mobileOpenButton) {
    mobileOpenButton.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        openModal(mobileOpenButton);
      }
    );
  }

  if (clearButton) {
    clearButton.addEventListener(
      'click',
      removeVehicle
    );
  }

  modal?.addEventListener(
    'click',
    (event) => {
      const closeTrigger = event.target.closest(
        '[data-trm-garage-modal-close]'
      );

      if (closeTrigger) {
        event.preventDefault();
        closeModal();
        return;
      }

      const backTrigger = event.target.closest(
        '[data-trm-garage-modal-back]'
      );

      if (backTrigger) {
        event.preventDefault();
        goModalBack();
        return;
      }

      const card = event.target.closest(
        '[data-trm-garage-modal-card]'
      );

      if (card) {
        event.preventDefault();
        selectModalCard(card);
      }
    }
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (!modalIsOpen()) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = getModalFocusable();

      if (focusable.length === 0) {
        event.preventDefault();
        modalDialog?.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[
        focusable.length - 1
      ];

      if (
        event.shiftKey &&
        document.activeElement === first
      ) {
        event.preventDefault();
        last.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === last
      ) {
        event.preventDefault();
        first.focus();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    captureVehicleSelection
  );

  window.addEventListener(
    'trm:garage-open',
    (event) => {
      openModal(event.detail?.trigger || null);
    }
  );

  const syncGaragePosition = () => {
    const header = document.querySelector('sticky-header');
    const headerHeight = header
      ? Math.max(0, Math.round(header.getBoundingClientRect().height))
      : 0;

    garage.style.setProperty('--trm-garage-top', `${headerHeight}px`);
    garage.style.setProperty('--trm-garage-top-mobile', `${headerHeight}px`);
    garage.classList.toggle('is-stuck', window.scrollY > 24);
  };

  syncGaragePosition();
  window.addEventListener('resize', syncGaragePosition, { passive: true });
  window.addEventListener('scroll', syncGaragePosition, { passive: true });

  if ('ResizeObserver' in window) {
    const header = document.querySelector('sticky-header');
    if (header) {
      new ResizeObserver(syncGaragePosition).observe(header);
    }
  }

  let selectedVehicle = readVehicle();

  const inferredVehicle =
    inferVehicleFromCurrentCollection();

  if (
    !selectedVehicle &&
    inferredVehicle
  ) {
    selectedVehicle =
      saveVehicle(inferredVehicle);
  } else {
    renderGarage(selectedVehicle);
  }

  if (selectedVehicle) {
    autoApplyToBrandCollection(
      selectedVehicle
    );

    autoRouteMainCategory(
      selectedVehicle
    );

    autoApplyToSearch(
      selectedVehicle
    );
  }

  window.addEventListener(
    'trm:vehicle-changed',
    (event) => {
      const vehicle = event.detail;

      if (vehicle?.preservePage) {
        return;
      }

      autoApplyToBrandCollection(vehicle);
      autoRouteMainCategory(vehicle);
      autoApplyToSearch(vehicle);
    }
  );

  window.TRMGarageV1 = {
    open: openModal,
    close: closeModal,
    readVehicle,
    saveVehicle,
    removeVehicle,
    vehicleData
  };
})();
